import Header, { DRAWER_ID } from "./Header";

export default Header;

export {
  DRAWER_ID,
};
